var exports = {
  "S": "xa15a2ab7--d88d36--image",
};

module.exports = exports;
